

import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import {
    Autocomplete,
    Box,
    Breadcrumbs,
    Button,
    Card,
    Chip,
    Grid,
    IconButton,
    Link,
    Menu,
    MenuItem,
    Paper,
    Typography,
} from "@mui/material";
import TextField from "@mui/material/TextField";
import { Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import {
    createSearchParams,
    Link as LinkRRD,
    useNavigate,
    useSearchParams,
} from "react-router-dom";
import LoadingUI from "../../comman/LoadingUI";
import NoDataFound from "../../comman/NoDataFound";
import SnackBarUI from "../../comman/SnackBarUI";
import Appbar from "../../components/Appbar";
// import DrawerUI from '../../components/Drawer'
import { dateConvert } from "../../helper/dateConverter";
import Body from "../../layout/Body";
import { useStyles } from "../../theme/theme";

import moment from "moment";

import { getChallengHistorygeAction } from "../../redux/toolkit/challenge/ChallengeHIstory";
import { userAttemptedChallengeAction, userAttemptedChallengeReducer } from "../../redux/toolkit/challenge/userAttemptedChallenge";
import { render } from "@testing-library/react";

// import Box from '@mui/material/Box';
// import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
// import Button from '@mui/material/Button';
// import Typography from '@mui/material/Typography';


const breadcrumb = (
    <Stack>
        <Breadcrumbs
            separator={
                <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
            }
            aria-label="breadcrumb"
        >
            <Link
                underline="hover"
                sx={{ color: "#5E6C8A" }}
                color="inherit"
                href="/"
            >
                Home
            </Link>
            <Link
                underline="hover"
                sx={{ color: "#5E6C8A" }}
                color="inherit"
                href="/userAttemptedChallenge"
            >
                User Attempted Challenge
            </Link>
        </Breadcrumbs>
        <Typography sx={{ color: "#5E6C8A" }} variant="h5">
            User Attempted Challenge
        </Typography>
    </Stack>
);

const bull = (
    <Box
        component="span"
        sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
    >
        •
    </Box>
);



const UsersAttemptedChallenge = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const challengeAttemptedData = useSelector((state) => state.userAttemptedChallenge);
    const { data, loading, total, status } = challengeAttemptedData;

    const [snack, setSnack] = useState(false);
    const [searchParams] = useSearchParams();
    // const challenge_id = searchParams.get("challenge_id");
    // const user_id = searchParams.get("user_id");

    const challenge_history_id = searchParams.get("challenge_history_id");

    const [pageSize, setPageSize] = useState(25);
    const [mission_id, setmission_id] = useState("");
    const classes = useStyles();

    const [date, setDate] = useState({
        start: null,
        end: null,
    });

    console.log("data================>", data);

    const qnsDataGridColumns = [
        {
            field: "s_no",
            headerName: "S. No.",
            filterable: false,
            flex: 1,
            minWidth:50,
            headerClassName: "super-app-theme--header",
            renderCell: (index) => index?.api?.getRowIndex(index.row._id) + 1,
        },

        {
            field: "question_id._id",
            headerName: "Question Id",
            flex: 1,
            minWidth: 270,
            headerClassName: "super-app-theme--header",
            renderCell: (params) => {
                return <Typography>{params?.row?.question_id?._id}</Typography>;
            },
        },

        {
            field: "question_id.title",
            headerName: "Question Title",
            flex: 1,
            minWidth: 270,
            headerClassName: "super-app-theme--header",
            renderCell: (params) => {
                return (
                    <Typography>{params?.row?.question_id?.title}</Typography>
                );
            },
        },

        {
            field: "selected_ans",
            headerName: "Selected Answer",
            flex: 1,
            minWidth: 250,
            headerClassName: "super-app-theme--header",
            renderCell: (params) => {

                return <Typography>{params?.row?.selected_ans}</Typography>;
            },
        },

         {
            field: "is_correct",
            headerName: "Is Correct",
            flex: 1,
            minWidth: 250,
            headerClassName: "super-app-theme--header",
            renderCell: (params) => {
                return <Typography>{params?.row?.is_correct ? "True" : "False"}</Typography>;
            },
        },

         {
            field: "lifeline_used",
            headerName: "Life Line Used",
            flex: 1,
            minWidth: 250,
            headerClassName: "super-app-theme--header",
            renderCell: (params) => {
                return <Typography>{params?.row?.lifeline_used ? params?.row?.lifeline_used?.name : "no"}</Typography>;
            },
        },

         {
            field: "mission_id",
            headerName: "Mission Id",
            flex: 1,
            minWidth: 250,
            headerClassName: "super-app-theme--header",
            renderCell: (params) => {
                return <Typography>{params?.row?.mission_id}</Typography>;
            },
        },


        // {
        //     field: "createdAt",
        //     headerName: "Created At",
        //     flex: 1,
        //     minWidth: 250,
        //     headerClassName: "super-app-theme--header",
        //     renderCell: (params) => {
        //         const date = params?.row?.created_at;
        //         return (
        //             <Typography>
        //                 {date ? moment(date).local().format("YYYY-MM-DD hh:mm::ss A") : "-"}
        //             </Typography>
        //         );
        //     },
        // }

    ];

    // use effect
    useEffect(() => {
        // dispatch(userAttemptedChallengeAction({ challenge_id: challenge_id , user_id :user_id}));
        dispatch(userAttemptedChallengeAction({ challenge_history_id: challenge_history_id }));
    }, [dispatch]);

    return (
        <>
            <Helmet>
                <title>User Attempted Challenge</title>
            </Helmet>
            <Appbar breadcrumb={breadcrumb} />
            <Body>

                

                <Stack direction="row" spacing={2}>
                    <Card sx={{ minWidth: 275, p: 2 }}>
                        <CardContent>
                            <Typography
                                gutterBottom
                                sx={{ color: "text.secondary", fontSize: 14, fontWeight: 600 }}
                            >
                                Attempt Information
                            </Typography>

                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                                <strong>User Name:</strong> {data[0]?.user_id?.name || "N/A"}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                                <strong>User ID:</strong> {data[0]?.user_id?._id || "N/A"}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                                <strong>Publisher Name:</strong> {data[0]?.publisher_id?.name || "N/A"}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                                <strong>Publisher ID:</strong> {data[0]?.publisher_id?._id || "N/A"}
                            </Typography>
                            <Typography variant="body2" sx={{ mb: 0.5 }}>
                                <strong>App Name:</strong> {data[0]?.app_id?.app_name || "N/A"}
                            </Typography>
                            <Typography variant="body2">
                                <strong>App ID:</strong> {data[0]?.app_id?._id || "N/A"}
                            </Typography>

                             <Typography variant="body2">
                                <strong>challenge_name:</strong> {data[0]?.challenge_id?.challenge_name || "N/A"}
                            </Typography>
                            <Typography variant="body2">
                                <strong>status:</strong> {data[0]?.status || "N/A"}
                            </Typography>
                             <Typography variant="body2">
                                <strong>reward:</strong> {data[0]?.reward || "N/A"}
                            </Typography>
                             <Typography variant="body2">
                                <strong>time_taken:</strong> {data[0]?.time_taken || "N/A"}
                            </Typography>
                        </CardContent>
                    </Card>

                    {
                        data[0]?.ch_mission?.map((item, index) => (
                            <Card sx={{ minWidth: 275, p: 2 }}>
                                <CardContent>
                                    <Typography
                                        gutterBottom
                                        sx={{ color: "text.secondary", fontSize: 14, fontWeight: 600 }}
                                    >
                                        Challenge Mission {index +1}
                                    </Typography>

                                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                                        <strong>Title:</strong> {item?.mis_id?.title || "N/A"}
                                    </Typography>
                                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                                        <strong>Mission Id:</strong> {item?.mis_id?._id || "N/A"}
                                    </Typography>
                                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                                        <strong>Time Taken</strong> {item?.time_taken || "N/A"}
                                    </Typography>

                                </CardContent>
                            </Card>
                        ))
                    }
                </Stack>

                <Typography>Question History...</Typography>

                <Card sx={{ my: 2 }}>
                    <Paper
                        sx={{
                            bgcolor: "#fff",
                            "& .super-app-theme--header": {
                                bgcolor: "#071D45",
                                color: "#fff",
                            },
                        }}
                        elevation={0}
                    >
                        <DataGrid
                            className={classes.root}
                            getRowHeight={() => "auto"}
                            sx={{ border: 0 }}
                            autoHeight
                            rows={data[0]?.question_history || []}
                            columns={qnsDataGridColumns}
                            getRowId={(row) => row._id}
                            disableSelectionOnClick
                            experimentalFeatures={{ newEditingApi: true }}
                            pagination
                            pageSize={pageSize}
                            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                            rowsPerPageOptions={[25, 50, 100]}
                            disableColumnSelector
                            loading={loading ? <LoadingUI /> : false}
                            onCellClick={(params) => {
                                setmission_id(params?.row?._id);
                            }}
                            components={{
                                NoRowsOverlay: () => <NoDataFound />,
                                Toolbar: GridToolbar,
                            }}
                        />
                    </Paper>
                </Card>
            </Body>
        </>
    );
}

export default UsersAttemptedChallenge